import { createReducer, on } from '@ngrx/store';
import { FieldDefValidations } from '@src/suite/common/enums/enums';

import { ApplicationActions } from '../navigation/actions/application.actions';
import { GlobalTablesActions } from './global-tables.actions';
import { GlobalTablesState } from './global-tables.models';

export const initialGlobalTablesState: GlobalTablesState = {
    Security: [],
    Apps: [],
    AllGroups: {},
    AllGroupsArray: [],
    Groups: {},
    GroupsArray: [],
    HomeServerGroups: [],
    EnterpriseGroup: null,
    PlaybookTeamsArray: [],
    DefaultPlaybookTeam: null,
    EnterprisePlaybookGroup: null,
    FieldMappings: [],
    CoverageTypeMOSMappings: [],
    MOSDevices: [],
    Privileges: [],
    Servers: {},
    Adorners: {},
    WireCategories: [],
    WireProviders: [],
    FieldDefs: [],
    FieldDefsDict: {},
    StorytellingNavigation: [],
    StorytellingNavigationDict: {},
    CustomFilterDef: [],
    CustomFilterDefsDict: {},
    Languages: [],
    PersonalLanguage: null,
    CommonTimeZones: [],
    IanaTimeZones: [],
    PersonalTimeZone: null,
    PersonalTimeZoneDisplay: null,
    ClientTimeZone: null,
    DefaultTimeZone: null,
    GroupSort: null,
    ViewStateFilters: null,
    securityPrivileges: {},
    PSTGroupId: null,
    DateTimeFields: {},
    ConfigSettings: {},
    Staff: {},
    PlaybookHelpUrl: '',
};

export const globalTablesReducer = createReducer(
    initialGlobalTablesState,
    on(ApplicationActions.sessionDestroyed, (): GlobalTablesState => {
        return initialGlobalTablesState;
    }),
    on(GlobalTablesActions.setGlobalFields, (state, { fieldsDefDict: fields, groupSortDefs, viewStateFiltersDefs }): GlobalTablesState => {
        const dateTimeFields: Record<string, boolean> = {};
        for (const id in fields) {
            if ([FieldDefValidations.TIME, FieldDefValidations.DATE, FieldDefValidations.MOSDATETIME].indexOf(fields[id].Validation.toUpperCase() as FieldDefValidations) > -1) {
                dateTimeFields[id] = true;
            }
        }
        return {
            ...state,
            FieldDefsDict: fields,
            GroupSort: groupSortDefs,
            DateTimeFields: dateTimeFields,
            ViewStateFilters: viewStateFiltersDefs,
        };
    }),
    on(GlobalTablesActions.setCustomFilterDefs, (state, { customFilterDefs, customFilterDefsDict }): GlobalTablesState => {
        return {
            ...state,
            CustomFilterDef: customFilterDefs,
            CustomFilterDefsDict: customFilterDefsDict,
        };
    }),
    on(GlobalTablesActions.setTimeZoneSettings, (state, { personalTimeZone, personalTimeZoneDisplay, clientTimeZone, defaultTimeZone }): GlobalTablesState => {
        return {
            ...state,
            PersonalTimeZone: personalTimeZone,
            PersonalTimeZoneDisplay: personalTimeZoneDisplay,
            DefaultTimeZone: defaultTimeZone,
            ClientTimeZone: clientTimeZone,
        };
    }),
    on(GlobalTablesActions.updateTimeZoneSettings, (state, { personalTimeZone, personalTimeZoneDisplay }): GlobalTablesState => {
        return {
            ...state,
            PersonalTimeZone: personalTimeZone,
            PersonalTimeZoneDisplay: personalTimeZoneDisplay,
        };
    }),

    on(GlobalTablesActions.setUserLocationPrivileges, (state, { securityPrivileges }): GlobalTablesState => {
        return {
            ...state,
            securityPrivileges: securityPrivileges,
        };
    }),
    on(GlobalTablesActions.setPstGroupId, (state, { pstGroupId }): GlobalTablesState => {
        return {
            ...state,
            PSTGroupId: pstGroupId,
        };
    }),
    on(GlobalTablesActions.setGlobalTables, (state, globalTables): GlobalTablesState => {
        return {
            ...state,
            ...globalTables,
        };
    }),
    on(GlobalTablesActions.setPlaybookHelpUrl, (state, { helpUrl }): GlobalTablesState => {
        return {
            ...state,
            PlaybookHelpUrl: helpUrl,
        };
    })
);
